module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fill_info == '') ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "panels"
  }, [_c('DocumentUploader', {
    ref: "igazolasfeltolto"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Külföldre ösztöndíjat nyert hallgatók útiköltségének támogatása")]), _vm._v(" "), _c('HallgatoAdatok', {
    on: {
      "onReady": function (hallgato, hallgato_szakok) {
        this$1.save_enabled = true;
        this$1.hallgato = hallgato;
        this$1.hallgato_szakok = hallgato_szakok
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "Adoszam",
      "regexp_filter": "[0-9-]+",
      "label": "Adóazonosító jel",
      "name": "Adoszam"
    },
    model: {
      value: (_vm.form.Adoszam),
      callback: function($$v) {
        _vm.form.Adoszam = $$v
      },
      expression: "form.Adoszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "mask": "99999999-99999999-99999999",
      "iconclass": "fa fa-pencil",
      "id": "Szamlaszam",
      "label": "Számlaszám",
      "name": "Szamlaszam"
    },
    model: {
      value: (_vm.form.Szamlaszam),
      callback: function($$v) {
        _vm.form.Szamlaszam = $$v
      },
      expression: "form.Szamlaszam"
    }
  })], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "FogadoOrszag",
      "label": "Fogadó ország",
      "iconclass": "fa fa-pencil",
      "name": "FogadoOrszag"
    },
    model: {
      value: (_vm.form.FogadoOrszag),
      callback: function($$v) {
        _vm.form.FogadoOrszag = $$v
      },
      expression: "form.FogadoOrszag"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "FogadoIntezmeny",
      "label": "Fogadó intézmény",
      "iconclass": "fa fa-pencil",
      "name": "FogadoIntezmeny"
    },
    model: {
      value: (_vm.form.FogadoIntezmeny),
      callback: function($$v) {
        _vm.form.FogadoIntezmeny = $$v
      },
      expression: "form.FogadoIntezmeny"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "Utikoltseg",
      "regexp_filter": "[0-9]+",
      "label": "Útiköltség",
      "iconText": "Ft",
      "name": "Utikoltseg"
    },
    model: {
      value: (_vm.form.Utikoltseg),
      callback: function($$v) {
        _vm.form.Utikoltseg = $$v
      },
      expression: "form.Utikoltseg"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "FogadoVaros",
      "label": "Fogadó város",
      "iconclass": "fa fa-pencil",
      "name": "FogadoVaros"
    },
    model: {
      value: (_vm.form.FogadoVaros),
      callback: function($$v) {
        _vm.form.FogadoVaros = $$v
      },
      expression: "form.FogadoVaros"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n                Az utazás módja\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.UtazasModja),
      expression: "form.UtazasModja"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "UtazasModja",
      "id": "UtazasModja"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.UtazasModja = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.utazasi_modok), function(um, i) {
    return _c('option', {
      domProps: {
        "value": um.value
      }
    }, [_vm._v(_vm._s(um.text))])
  })), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'UtazasModja') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "name": "kuld",
      "disabled": !_vm.save_enabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Beküld")])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fill_info != ''),
      expression: "fill_info != ''"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Külföldre ösztöndíjat nyert hallgatók útiköltségének támogatása")]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  }, [_vm._v(_vm._s(_vm.fill_info))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Adószám, számlaszám")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Utazás adatai")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n          Az adatlaphoz mellékelni kell a pályázati kiírásban meghatározott igazolásokat. "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Az elszámolási kötelezettségeknek legkésőbb a 2018/2019-es tanév őszi szemeszterének utolsó napjáig kell eleget tenni.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45ead61b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/kulfoldi_utikoltseg_palyazat.vue
// module id = 365
// module chunks = 0